'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // imports


var _mediaEvents = require('./ads/media/mediaEvents');

var _mediaEvents2 = _interopRequireDefault(_mediaEvents);

var _Events = require('./ads/media/Events');

var _Events2 = _interopRequireDefault(_Events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mint = require('./core/mint');

// public interface
var api = {
  init: function init(settings) {
    return mint.init(settings);
  },
  handleInstreamAds: function handleInstreamAds(adData) {
    return mint.handleInstreamAds(adData);
  },
  requestScreen: function requestScreen(params) {
    return mint.requestScreen(params);
  },
  requestSlot: function requestSlot(elementId) {
    return mint.requestSlot(elementId);
  },
  requestPremiumUnlockActivity: function requestPremiumUnlockActivity(parameters) {
    return mint.requestPremiumUnlockActivity(parameters);
  },
  registerSlot: function registerSlot(elementId, slotName, dimensions) {
    return mint.registerSlot(elementId, slotName, dimensions);
  },
  deregisterSlot: function deregisterSlot(elementId) {
    return mint.deregisterSlot(elementId);
  },
  clearSlot: function clearSlot(slotName, shouldIgnoreAdVisibilityEventOnce) {
    mint.clearSlot(slotName, shouldIgnoreAdVisibilityEventOnce);
  },
  clearState: function clearState(stateName) {
    return mint.updateState(stateName, undefined);
  },
  updateState: function updateState(stateName, value) {
    return mint.updateState(stateName, value);
  },
  updateUnlockDetails: function updateUnlockDetails(unlock) {
    return mint.updateUnlockDetails(unlock);
  },
  getState: function getState(stateName) {
    return mint.getState(stateName);
  },
  addLotameInterests: function addLotameInterests(interests) {
    return mint.addLotameInterests(interests);
  },
  triggerLotameTargeting: function triggerLotameTargeting(interests) {
    return mint.triggerLotameTargeting(interests);
  },
  disableAds: function disableAds() {
    return mint.disableAds();
  },
  preload: function preload() {
    mint.preload();
  },
  play: function play(position) {
    mint.play(position);
  },
  pause: function pause() {
    mint.pause();
  },
  stop: function stop() {
    mint.stop();
  },
  volume: function volume(_volume) {
    mint.volume(_volume);
  },
  resize: function resize(width, height) {
    mint.resize(width, height);
  },
  event: function event() {
    return _mediaEvents2.default.event.apply(_mediaEvents2.default, arguments);
  },
  getPalNonce: function getPalNonce() {
    return mint.getPalNonce();
  },
  hasMetPrerollQuota: function hasMetPrerollQuota() {
    return mint.hasMetPrerollQuota();
  }
};

module.exports = _extends({}, api, {
  Events: _Events2.default
});